import React from "react";
import S1 from "../../assets/sh1.svg";
import S2 from "../../assets/sh2.svg";
import S3 from "../../assets/sh3.svg";
import S4 from "../../assets/sh4.svg";
import S5 from "../../assets/sh5.svg";
import S6 from "../../assets/sh6.svg";

function Card() {
  return (
    <div className="py-[50px] px-[45px] md:py-[100px] ">
      <div>
        <h2 className="text-tahiti text-[20px] md:text-[50px] leading-[59px]  text-center font-[700] pb-[20px]">
          {" "}
          <span className="text-tahiti-secondary "> Shop</span> Without worries
        </h2>
        <p className="max-w-[440px] mx-auto text-[14px] md:text-[20px]  text-center font-[400] leading-[24px] md:leading-[34px]">
          Enjoy A Pleasant And Unforgettable Online Shopping Experience With
          Shopaz HUb E-Marketplace
        </p>
      </div>

      <div className="max-w-[795px] mx-auto">
        <div className="flex flex-col md:flex-row lg:flex-row md:gap-[30px] lg:gap-[156px] pt-[50px]">
          <div className="basis-full pb-[50px] md:pb-0 md:basis-1/3  lg:basis-[135px]">
            {/* svg icon */}

            <div className="flex justify-center pb-[30px]">
              {" "}
              <img src={S1} alt="card-item" />
            </div>
            <h3 className="text-[24px] font-[500] leading-[26px] text-center text-[#000000]  pb-[20px]">
              {" "}
              Product
            </h3>
            <p className="text-center font-[400] text-[16px] text-[#000000] max-w-[135px] mx-auto">
              Get a wide variety of products at an amazing rate
            </p>
          </div>
          <div className="basis-full   pb-[50px] md:pb-0  md:basis-1/3 lg:basis-[183px]">
            <div className="flex justify-center pb-[30px]">
              {" "}
              <img src={S2} alt="card-item" />
            </div>
            <h3 className="text-[24px] font-[500] leading-[26px] text-center text-[#000000]  pb-[20px]">
              {" "}
              Flash sales
            </h3>
            <p className="text-center font-[400] text-[16px] text-[#000000] max-w-[183px] mx-auto">
              {" "}
              Enjoy mouth-watering discounts, flash sales, and coupons.
            </p>
          </div>
          <div className="basis-full   pb-[50px] md:pb-0   md:basis-1/3  lg:basis-[165px]">
            <div className="flex justify-center pb-[30px]">
              <div className="flex justify-center">
                {" "}
                <img src={S3} alt="card-item" />
              </div>
            </div>
            <h3 className="text-[24px] font-[500] leading-[26px] text-center text-[#000000]  pb-[20px]">
              {" "}
              Service
            </h3>
            <p className="text-center font-[400] text-[16px] text-[#000000] max-w-[165px] mx-auto">
              {" "}
              Enjoy top-notch customer service
            </p>
          </div>
        </div>
        <div className="flex flex-col md:flex-row lg:flex-row md:gap-[30px] lg:gap-[140px] pt-[50px]">
          <div className=" basis-full   pb-[50px] md:pb-0  md:basis-1/3 lg:basis-[186px]">
            {/* svg icon */}

            <div className="flex justify-center pb-[30px]">
              {" "}
              <img src={S4} alt="card-item" />
            </div>
            <h3 className="text-[24px] font-[500] leading-[26px] text-center text-[#000000]  pb-[20px]">
              {" "}
              Delivery
            </h3>
            <p className="text-center font-[400] text-[16px] text-[#000000] max-w-[186px] mx-auto">
              {" "}
              Enjoy breathtaking delivery of your purchases
            </p>
          </div>
          <div className=" basis-full   pb-[50px] md:pb-0   md:basis-1/3 lg:basis-[184px]">
            <div className="flex justify-center pb-[30px]">
              {" "}
              <img src={S5} alt="card-item" />
            </div>
            <h3 className="text-[24px] font-[500] leading-[26px] text-center text-[#000000]  pb-[20px]">
              {" "}
              Charity
            </h3>
            <p className="text-center font-[400] text-[16px] text-[#000000] max-w-[184px] mx-auto">
              {" "}
              Having 2% of your payment for every item goes to charity towards
              helping out-of-school kids in slum locations go back to school.
            </p>
          </div>
          <div className=" basis-full   pb-[50px] md:pb-0   md:basis-1/3 lg:basis-[181px]">
            <div className="flex justify-center pb-[30px]">
              {" "}
              <img src={S6} alt="card-item" />
            </div>
            <h3 className="text-[24px] font-[500] leading-[26px] text-center text-[#000000]  pb-[20px]">
              {" "}
              Menace
            </h3>
            <p className="text-center font-[400] text-[16px] text-[#000000] max-w-[165px] mx-auto">
              {" "}
              Not worrying about the online buying menace known as “what I
              ordered vs what I got”
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;
